// extracted by mini-css-extract-plugin
export default {"cls1":"KkCn6VK3XyIIJK0IQHxe","cls2":"HQWVmeVbr0Zp7kFD09MF KkCn6VK3XyIIJK0IQHxe"};